import { FC } from 'react';
import type { RichTextField } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';

type Props = { title: RichTextField };

// PrismicRichText is used (over `asText`) so that Shift+Enter in the editor
// lands as `\n` in the span text and the default span serializer inserts a
// `<br />` — same behaviour as the redesign hero's headline.
export const CalloutTitle: FC<Props> = ({ title }) => (
  <PrismicRichText
    field={title}
    components={{
      heading2: ({ children }) => (
        <h2 className="text-balance text-[24px] font-medium leading-[1.4] text-white md:text-[30px]">
          {children}
        </h2>
      ),
    }}
  />
);
